import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import {
  Input,
  Radio,
  SearchInput,
  Textarea,
} from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import { validaSoloNumero } from "../../../../util/varios";
import CatalogoClasificadorDeBienes from "../../../../catalogos/catalogoClasificadorDeBienes";
import CatalogoTipoActivos from "../../../../catalogos/catalogoTipoActivos";
const op = require("../../../../modulos/datos");

export default function CatalogoActivos({ show, setShow, setTabla }) {
  const token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();

  //catalogo activos
  const txtId = useRef();
  const txtCodigoActivo = useRef();
  const txtDescripcion = useRef();
  const radioMueble = useRef();
  const radioInmueble = useRef();
  const txtTipoMaterial = useRef();

  //clasificador bienes
  const txtCodClasificaBienes = useRef();
  const txtGrupo = useRef();
  const txtSubGrupo = useRef();
  const txtSeccion = useRef();
  const txtDescripClaseBien = useRef();

  const [txtOperacion, setTxtOperacion] = useState("");
  const [operacion, setOperacion] = useState(0);
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogoTipo, setMostrarCatalogoTipo] = useState(false);
  const [mostrarCatalogoClasificador, setMostrarCatalogoClasificador] =
    useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const blanquear = () => {
    txtId.current.value = "";
    txtCodigoActivo.current.value = "";
    txtDescripcion.current.value = "";
    radioMueble.current.checked = true;
    radioInmueble.current.checked = false;
    txtTipoMaterial.current.value = "";

    txtCodClasificaBienes.current.value = "";
    txtGrupo.current.value = "";
    txtSubGrupo.current.value = "";
    txtSeccion.current.value = "";
    txtDescripClaseBien.current.value = "";

    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabled(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
  };

  const seleccionaclasificador = async (id) => {
    const campos = "*";
    const nomtab = "clasificabienes";
    const nomid = "idclasificabienes";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtGrupo.current.value = data.grupo.trim();
            txtSubGrupo.current.value = data.subgrupo.trim();
            txtSeccion.current.value = data.seccion.trim();
            txtDescripClaseBien.current.value = data.descripcion.trim();
            setDisabled(operacion !== 2);
            setActivate(false);
          } else {
            txtGrupo.current.value = "";
            txtSubGrupo.current.value = "";
            txtSeccion.current.value = "";
            txtDescripClaseBien.current.value = "";

            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un clasificador con ese codigo.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionatipoactivo = async () => {
    const campos = "*";
    const id = txtId.current.value;
    const nomtab = "tipoactivo";
    const nomid = "idtipoactivo";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtCodigoActivo.current.value = data.codigoactivo.trim();
            txtDescripcion.current.value = data.descripcion.trim();
            if (data.tipobien === 0) {
              radioMueble.current.checked = true;
            } else {
              radioInmueble.current.checked = true;
            }
            if (op.espiritu !== 7) {
              txtTipoMaterial.current.value = data.tipomaterial;
            }
            txtCodClasificaBienes.current.value = data.idclasificabienes;
            setDisabled(operacion !== 2);
            await seleccionaclasificador(data.idclasificabienes);
          } else {
            txtCodigoActivo.current.value = "";
            txtDescripcion.current.value = "";
            radioMueble.current.checked = true;
            radioInmueble.current.checked = false;
            txtTipoMaterial.current.value = "";

            txtCodClasificaBienes.current.value = "";
            txtGrupo.current.value = "";
            txtSubGrupo.current.value = "";
            txtSeccion.current.value = "";
            txtDescripClaseBien.current.value = "";

            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un clasificador con ese codigo.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/tipoactivo/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let msm = "";
          if (operacion === 1) {
            msm =
              "registro " +
              response.data.tipoactivo_act +
              " creado correctamente";
          } else if (operacion === 2) {
            msm =
              "registro " +
              response.data.tipoactivo_act +
              " modificado correctamente";
          } else if (operacion === 3) {
            msm =
              "registro " +
              response.data.tipoactivo_act +
              " eliminado correctamente";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msm,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "tipoactivo_pkey"`
        ) {
          mensaje = "Ya Existe un tipo activo con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const onChangeValidar = async () => {
    let sigue = true;

    if (operacion !== 1 && txtId.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el codigo.`,
        icono: "informacion",
      });
      sigue = false;
      txtId.current.focus();
    } else if (txtCodigoActivo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `el campo codigo del activo no puede estar vacio.`,
        icono: "informacion",
      });
      sigue = false;
      txtCodigoActivo.current.focus();
    } else if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `el campo descripcion del activo no puede estar vacio.`,
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    } else if (txtTipoMaterial.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "el campo tipo material no puede estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtTipoMaterial.current.focus();
    } else if (txtCodClasificaBienes.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "el campo codigo de la clase bien no puede estar vacio.",
        icono: "informacion",
      });
      sigue = false;
      txtCodClasificaBienes.current.focus();
    }

    if (sigue) {
      const datos = {
        operacion: operacion,
        idtipoactivo:
          txtId.current.value === "" ? "0" : txtId.current.value.trim(),
        descripcion: txtDescripcion.current.value.trim().toUpperCase(),
        tipobien: radioMueble.current.checked ? 0 : 1,
        tipomaterial: txtTipoMaterial.current.value.trim().toUpperCase(),
        idclasificabienes:
          txtCodClasificaBienes.current.value === ""
            ? 0
            : txtCodClasificaBienes.current.value,
        codigoactivo: txtCodigoActivo.current.value.trim().toUpperCase(),
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigoactivo") {
        txtDescripcion.current.focus();
      } else if (e.target.name === "tipomaterial") {
        btnAcepta.current.focus();
      }
    }
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtId.current.blur();
        seleccionatipoactivo();
      } else {
        txtCodigoActivo.current.value = "";
        txtDescripcion.current.value = "";
        radioMueble.current.checked = true;
        radioInmueble.current.checked = true;
        txtTipoMaterial.current.value = "";
        txtCodClasificaBienes.current.value = "";
        txtGrupo.current.value = "";
        txtSubGrupo.current.value = "";
        txtSeccion.current.value = "";
        txtDescripClaseBien.current.value = "";
      }
    }
  };

  const validarCodigoclasificador = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodClasificaBienes.current.blur();
        seleccionaclasificador(event.target.value);
      } else {
        txtGrupo.current.value = "";
        txtSubGrupo.current.value = "";
        txtSeccion.current.value = "";
        txtDescripClaseBien.current.value = "";
      }
    }
  };

  const onHideCatalogoTipo = (value = false) => {
    setMostrarCatalogoTipo(false);
    if (value) {
      txtId.current.value = value.idtipoactivo;
      seleccionatipoactivo();
    }
  };

  const onHideCatalogo = (value = false) => {
    setMostrarCatalogoClasificador(false);
    if (value) {
      txtCodClasificaBienes.current.value = value.idclasificabienes;
      seleccionaclasificador(value.idclasificabienes);
    }
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      setDisabled(false);
      setTimeout(() => {
        txtCodigoActivo.current.focus();
      }, 200);
    } else if (value === 2) {
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigoActivo.current.focus();
      }, 200);
    } else if (value === 3) {
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigoActivo.current.focus();
      }, 200);
    } else if (value === 4) {
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigoActivo.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Catalogo de Activos {txtOperacion}</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-4 m-0 mb-2 p-0">
          <SearchInput
            ref={txtId}
            disabled={operacion < 2}
            onKeyUp={validarCodigo}
            onBlur={validarCodigo}
            label="Código:"
            name="idtipoactivo"
            onClickButton={() => setMostrarCatalogoTipo(true)}
            disabledButton={operacion < 2}
          />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Input
            name="codigoactivo"
            label="Código del Activo:"
            ref={txtCodigoActivo}
            disabled={disabled}
            maxLength={3}
            onChange={onChange}
            onKeyUp={onNextChange}
          />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea
            label="Descripción Activo:"
            ref={txtDescripcion}
            disabled={disabled}
            onChange={onChange}
            onKeyUp={onNextChange}
            name="descripcion"
            style={{ height: 70 }}
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Tipo de Bien</legend>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Mueble"
              name="tipobien"
              id="tipobien1"
              ref={radioMueble}
              disabled={disabled}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Inmueble"
              name="tipobien"
              id="tipobien2"
              ref={radioInmueble}
              disabled={disabled}
            />
          </div>
        </fieldset>
        <diva className="col-12 m-0 mb-2 p-0">
          <Input
            label="Tipo Material:"
            name="tipomaterial"
            ref={txtTipoMaterial}
            disabled={disabled}
            onChange={onChange}
            onKeyUp={onNextChange}
          />
        </diva>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">Clase de bien</legend>
          <div className="col-3 m-0 p-0">
            <SearchInput
              ref={txtCodClasificaBienes}
              disabled={operacion !== 1 && operacion !== 2}
              onKeyUp={validarCodigoclasificador}
              onBlur={validarCodigoclasificador}
              label="Código:"
              name="codigo"
              onClickButton={() => setMostrarCatalogoClasificador(true)}
              disabledButton={operacion !== 1 && operacion !== 2}
            />
          </div>
          <div className="col-3 m-0 p-0 pl-2">
            <Input ref={txtGrupo} disabled label="Grupo:" name="grupo" />
          </div>
          <div className="col-3 m-0 p-0 pl-2">
            <Input
              ref={txtSubGrupo}
              disabled
              label="Subgrupo:"
              name="subgrupo"
            />
          </div>
          <div className="col-3 m-0 p-0 pl-2">
            <Input ref={txtSeccion} disabled label="Sección:" name="seccion" />
          </div>
          <div className="col-12 m-0 mt-2 p-0">
            <Textarea
              ref={txtDescripClaseBien}
              disabled
              label="Descripción:"
              name="descripcion"
              style={{ height: 70 }}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoClasificadorDeBienes
        show={mostrarCatalogoClasificador}
        onHide={onHideCatalogo}
      />

      <CatalogoTipoActivos
        show={mostrarCatalogoTipo}
        onHide={onHideCatalogoTipo}
      />
    </Modal>
  );
}
